import { useLayoutEffect } from 'react';
import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares';
import { useInstantSearch } from 'react-instantsearch-hooks-web';

// Used for view tracking
// https://www.algolia.com/doc/guides/sending-events/connectors/google-tag-manager/#send-hits-viewed-event
const InsightsMiddleware = () => {
	const { use } = useInstantSearch();

	useLayoutEffect( () => {
		if ( ! window.aa ) {
			console.log( 'Insights library not loaded' );
		}
		const middleware = createInsightsMiddleware( {
			insightsClient: window.aa,
			insightsInitParams: {
				useCookie: true,
			},
			onEvent: ( event ) => {
				const { insightsMethod } = event;

				if ( ! window.dataLayer ) {
					return;
				}

				// https://www.algolia.com/doc/guides/sending-events/connectors/google-tag-manager/#send-hits-viewed-event
				if ( insightsMethod === 'viewedObjectIDs' ) {
					window.dataLayer.push( { event: 'Hits Viewed' } );
				}

				// Send the event to Algolia
				// if ( insightsMethod ) {
				// 	aaProp( insightsMethod, payload );
				// }
			},
		} );

		return use( middleware );
	}, [ use ] );

	return null;
};

export default InsightsMiddleware;
